import request from '@/utils/request.js'

export const addFeedBack = (data) => {
    return request({
        url: '/api/feedback/add',
        method: 'POST',
        data
    })
};

export const eventList = (params) =>{ 
    return request({
        url: '/api/event/list',
        method: 'GET',
        params
    })    
};

export const info = (data) => {
    return request({
        url: '/api/info/fetch',
        method: 'POST',
        data
    })
};


